// extracted by mini-css-extract-plugin
export default {"form":"FormExtraction_form__0hWlz","actions":"FormExtraction_actions__MRKSD"};